<template>
  <div>
    <search
      :title="`${$t('modal.terminal')}`"
      :items="terminals"
      idProperty="TerminalId"
      nameProperty="TerminalName"
      @triggerClick="triggerClick"
      @remove="remove"
      :searchItems="searchItems"
    />

    <terminal-select
      :isMultiple="true"
      :trigger="trigger"
      :defaultItems="defaultItems"
      @onSaved="add"
    />
  </div>
</template>

<script>
import search from "./Search";
import terminalSelect from "@/components/selects/TerminalSelects";

export default {
  data() {
    return {
      trigger: false,
      terminals: [],
      defaultItems: undefined,
    };
  },
  props: {
    searchItems: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    searchItems(value) {
      if (JSON.parse(sessionStorage.getItem("isSamePage")) && value.Terminal) {
        this.terminals = value.Terminal;
      }
    },
  },
  components: {
    search,
    terminalSelect,
  },
  methods: {
    triggerClick() {
      this.defaultItems = [...this.terminals];
      this.trigger = !this.trigger;
    },
    add(items) {
      this.terminals = items;
      this.set();
    },
    remove(index) {
      if (!this.terminals[index]) return;
      this.terminals.splice(index, 1);
      this.set();
    },
    set() {
      this.$emit("set", this.terminals);
    },
  },
};
</script>
